import React, {useState, useEffect} from "react";
import EditablePdf from "../../../components/forms/EditablePdf";
import {Grid, Col} from "../../../styles/Grid";
import styled from "styled-components";
import SessionGenerator from "./sessions/SessionGenerator";
import {Input, Label} from "../../../components/forms/DynamicInput";
import EditableImg from "../../../components/forms/EditableImg";
import {AppButton, ResetButton} from "../../../styles/Butttons";
import nextId from "react-id-generator";
import MediaCreator from "./media/MediaCreator";
import {CreateResourceCourse, CreateThemeCourse, CreateSubthemeCourse} from "../../../services/GeneralServices";
import AppLoader, {StatusLoader} from "../../../components/loaders/Loader";
import SessionsList from "./sessions/SessionsList";
import {ReactComponent as PlusIcon} from "../../../assets/icons/plus.svg";
import Color from "../../../assets/colors";
import {useHistory} from "react-router-dom";

const FormPartThree = React.forwardRef((props, ref) => {
   const [themaryList, setThemary] = useState([
      {
         id: nextId(),
         title: "Clase 1",
         subclass: [{name: "", nextId: "c" + nextId()}],
      },
      {
         id: nextId(),
         title: "Clase 1",
         subclass: [
            {name: "Tema 1", id: "A"},
            {name: "Tema 2", id: "B"},
            {name: "Tema 2", id: "C"},
            {name: "Tema 2", id: "D"},
         ],
      },
   ]);
   const [isSaving, setSaving] = useState("");
   const [isLoading, setLoading] = useState(false);
   const [validThemes, setValidThemes] = useState([]);
   let history = useHistory();

   useEffect(() => {
      if (validThemes.length >= 1) {
         saveThemes();
      }
   }, [validThemes]);

   const addTheme = () => {
      let newClass = {
         id: nextId(),
         title: "",
         subclass: [{name: ""}],
      };
      setThemary([...themaryList, {...newClass}]);
   };
   const deleteTheme = (id) => {
      let newThemes = themaryList.filter((item) => item.id !== id);
      // console.log(newThemes);
      setThemary(newThemes);
   };

   const addClass = (id) => {
      let cleanClass = {name: "", id: "c" + nextId()};

      let newThemes = themaryList.map((item) => {
         if (item.id === id) {
            let newClasses = [...item.subclass, {...cleanClass}];
            let newItem = {...item, subclass: [...newClasses]};
            return newItem;
         }
         return item;
      });
      setThemary(newThemes);
   };

   const deleteClass = (idTheme, idClass) => {
      let newThemes = themaryList.map((item) => {
         if (item.id === idTheme) {
            let newClasses = item.subclass.filter((cla) => cla.id !== idClass);
            let newItem = {...item, subclass: [...newClasses]};
            return newItem;
         }
         return item;
      });
      setThemary(newThemes);
   };

   const setVal = (id, target, val) => {
      let newThema = themaryList.map((item) => {
         if (id === item.id) {
            return {...item, [target]: val};
         }
         return item;
      });
      setThemary(newThema);
   };

   const changeClass = (idTheme, idClass, val) => {
      let newThemes = themaryList.map((item) => {
         if (item.id === idTheme) {
            let newClasses = item.subclass.map((itemClass) => {
               if (itemClass.id === idClass) {
                  return {...itemClass, name: val};
               }
               return itemClass;
            });
            let newItem = {...item, subclass: [...newClasses]};
            return newItem;
         }
         return item;
      });
      setThemary(newThemes);
   };

   const saveThemary = () => {
      setLoading(true);
      let isPossible = true;
      let listValid = themaryList.map((them) => {
         if (them.title) {
            isPossible = !isPossible ? false : true;
            return {...them, valid: true};
         } else {
            let needSave = false;
            them.subclass.map((cla) => {
               if (!needSave) {
                  if (cla.name.length > 0) {
                     console.log("Tiene textp, neccesita titulo", cla.name);
                  }
                  needSave = cla.name.length > 0;
                  console.log("current name", cla.name, needSave);
               }

               return cla;
            });
            // console.log("Alguno tiene texto", needSave);
            isPossible = needSave ? false : true;
            return {...them, valid: isPossible};
         }
      });
      if (isPossible) {
         // console.log("Se puede enviar", isPossible);
         setValidThemes(listValid);
      } else {
         setThemary(listValid);
         setLoading(false);
      }
   };

   const saveThemes = () => {
      // enviar el dato 0
      saveTheme(validThemes[0], 0);
   };

   const saveTheme = (val, ind) => {
      // cada thema envis sus sustemas
      setSaving(`Guardando: ${val.title}`);
      // console.log("Gaurdar THEME: ", val.title);
      if (!val.subclass || val.subclass.length === 0) {
         return createNext(ind);
      }
      let toSend = {
         idCourse: props.idCourse,
         title: val.title,
      };

      CreateThemeCourse(toSend)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            for (let nClas in val.subclass) {
               nClas = Number(nClas);
               saveClass(val.subclass[nClas], data.idTemaryClasses);
               if (nClas + 1 === val.subclass.length) {
                  createNext(ind);
               }
            }
         })
         .then(() => {
            createNext(ind);
         })
         .catch((e) => {
            createNext(ind);
         });
   };
   const createNext = (ind) => {
      console.log("create NEXT: --", ind);
      if (ind < validThemes.length - 1) {
         saveTheme(validThemes[ind + 1], ind + 1);
      } else {
         setLoading(false);
         props.continue();
      }
   };

   const saveClass = (val, idTemaryClasses) => {
      if (val.name) {
         let toSend = {
            idTemaryClasses,
            name: val.name,
         };
         CreateSubthemeCourse(toSend)
            .then((res) => res.json())
            .then((resp) => {
               const {status, data} = resp;
               if (status === "error") throw new Error();
            })
            .catch((e) => {
               console.log(e);
            });
      }
   };

   return (
      <>
         <AllGrid>
            <Col large={12}>
               <TitleSecion>Temarío de curso:</TitleSecion>
            </Col>
            <Grid>
               {React.Children.toArray(
                  themaryList.map((item) => {
                     return (
                        <Col large={3.5}>
                           <SessionsList
                              data={item}
                              change={setVal}
                              addClass={addClass}
                              deleteTheme={deleteTheme}
                              deleteClass={deleteClass}
                              changeClass={changeClass}
                           />
                        </Col>
                     );
                  }),
               )}
               <Col large="1">
                  <AddButton onClick={addTheme} className="add">
                     <PlusIcon width="1.5em" height="1.5em" className="icon" fill={Color.primary} />
                  </AddButton>
               </Col>
            </Grid>
            <Col large="2" offsetL={10}>
               <AppButton onClick={saveThemary}>Guardar</AppButton>
            </Col>
         </AllGrid>
         <StatusLoader isVisible={isLoading} status={isSaving} />
      </>
   );
});

export default FormPartThree;

const AllGrid = styled(Grid)`
   .sepTop {
      margin-top: 2em;
   }
`;

const TitleSecion = styled.p`
   font-size: 1.5em;
   font-weight: 400;
   color: #1c355e;
   margin: 1em 0 1.5em 0;
`;

const AddButton = styled.button`
   display: flex;
   align-items:center;
   justify-content: center;
   background: #32529d;

   border-radius: 50%;
   margin-left: 1em;

   &.add {
      width: 2em;
      height: 2em;
   }

   & .icon {
      // fill: ${Color.primary};
      width: 1em;
      heigth: 1em;
   }
`;

const MediaCol = styled(Col)`
   display: flex;
   align-items: flex-end;

   & ${ResetButton} {
      width: auto;
      padding: 0.3em 0.5em;
      height: fit-content;
      color: crimson;
   }

   .row {
      width: 90%;
   }

   &.sepTop {
      margin-top: 1em;
   }
`;

const Title = styled.p``;

const ClasesText = styled.textarea`
   font-size: 1em;
   font-family: Montserrat;
   resize: none;
   width: 100%;
   height: 120px;
   margin: 0.5em 0;
`;
